export const titleFromContentPage = (country, metaData) => {
  if (metaData) {
    return metaData.metaTitle ? metaData.metaTitle : "Westfield ".concat(metaData.title);
  } else {
    return "Westfield ".concat(country);
  }
};